import { Component } from '@angular/core';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';

import { TermsAndConditionsService } from '../../_services/terms-and-conditions/terms-and-conditions.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SafeUrlPipe } from 'src/app/Shared/_pipes/safe-url.pipe';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { LocalDateTimePipe } from 'src/app/Shared/_pipes/local-date-time';
@Component({
    selector: 'app-terms-conditions-view',
        standalone: true,
imports: [
    SafeUrlPipe,
    MatProgressSpinner,
    TranslatePipe,
    LocalDateTimePipe
],
    templateUrl: './terms-conditions-view.component.html',
    styleUrl: './terms-conditions-view.component.scss'
})
export class TermsConditionsViewComponent {
  currentLang: any;
  auctionId!: any;
  termsAndConditions: any = {};
  hasMedia!: number;
  updatedAt: any;
  ConsignorName: string = '';
  content: string = '';
  contentType: string = '';
  isLoading!: boolean;
  type!: string;
  termId!: number;
  constructor(
    private translate: TranslateService,
    private termsConditionsService: TermsAndConditionsService,
    private toastService: ToastService,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.type = params.get('type')!;
      if (this.type == 'auction') {
        this.auctionId = +params.get('auctionId')!;
        if (this.auctionId) {
          this.getBuyerTermsAndConditions();
        }
      } else if (this.type == 'terms') {
        this.termId = +params.get('auctionId')!;
        this.getTermsAndConditionsById();
      } else if (!this.type) {
        const isPrivate = this.route.snapshot.queryParams['is_private'];
        this.getSellerTermsAndConditions(isPrivate);
      }
    });
  }
  getBuyerTermsAndConditions() {
    this.isLoading = true;
    this.termsConditionsService
      .getTermsAndConditions({
        auction_id: this.auctionId,
      })
      .subscribe({
        next: (res) => {
          this.isLoading = false;

          this.termsAndConditions = res.data;
          this.hasMedia =
            this.termsAndConditions?.seller_terms_and_conditions?.has_media;
          this.content =
            this.hasMedia === 1
              ? this.termsAndConditions?.seller_terms_and_conditions?.content
                  ?.url
              : this.termsAndConditions?.seller_terms_and_conditions?.content
                  .content;
          this.contentType =
            this.termsAndConditions?.seller_terms_and_conditions?.content.type;
          this.updatedAt =
            this.termsAndConditions?.seller_terms_and_conditions?.created_at;
          this.ConsignorName =
            this.termsAndConditions?.seller_terms_and_conditions?.consignor_name;
        },
        error: (err) => {
          this.isLoading = false;
          this.toastService.showError(err?.error?.Error[0]);
        },
      });
  }

  getTermsAndConditionsById() {
    this.isLoading = true;
    this.termsConditionsService
      .viewSellerTermsAndConditionsByTermsID({
        terms_and_conditions_id: this.termId,
      })
      .subscribe({
        next: (res) => {
          this.isLoading = false;

          this.termsAndConditions = res.data;
          this.hasMedia =
            this.termsAndConditions?.seller_terms_and_conditions?.has_media;
          this.content =
            this.hasMedia === 1
              ? this.termsAndConditions?.seller_terms_and_conditions?.content
                  ?.url
              : this.termsAndConditions?.seller_terms_and_conditions?.content
                  .content;
          this.contentType =
            this.termsAndConditions?.seller_terms_and_conditions?.content.type;
          this.updatedAt =
            this.termsAndConditions?.seller_terms_and_conditions?.created_at;
          this.ConsignorName =
            this.termsAndConditions?.seller_terms_and_conditions?.consignor_name;
        },
        error: (err) => {
          this.isLoading = false;
          this.toastService.showError(err?.error?.Error[0]);
        },
      });
  }
  getSellerTermsAndConditions(isPrivate: number) {
    this.isLoading = true;
    this.termsConditionsService
      .showTermsAndConditions({ is_private: isPrivate, version: '' })
      .subscribe({
        next: (res) => {
          this.isLoading = false;

          const termsAndConditions = res.data;
          this.hasMedia =
            termsAndConditions?.terms_and_conditions?.type !== 'content'
              ? 1
              : 0;
          this.content =
            this.hasMedia === 1
              ? termsAndConditions?.terms_and_conditions?.url
              : termsAndConditions?.terms_and_conditions?.content;
          this.contentType = termsAndConditions?.terms_and_conditions?.type;
          this.updatedAt = termsAndConditions?.terms_and_conditions?.created_at;
          this.ConsignorName =
            termsAndConditions?.terms_and_conditions?.consignor_name;
        },
        error: (err) => {
          this.isLoading = false;
          this.toastService.showError(err?.error?.Error[0]);
        },
      });
  }
}
